import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Route, Switch } from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import {
  APP_NAV_DRAWER_HEADER_TYPE,
} from '../../services/ViewService';
import VerticalDrawerLink from './VerticalDrawerLink';
import DrawerLinks from './DrawerLinks';
import './NavDrawer.scss';

class NavDrawer extends React.PureComponent {
  static propTypes = {
    routes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    sortedRoutes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    location: PropTypes.shape({ search: PropTypes.string }).isRequired,
    open: PropTypes.bool.isRequired,
    variant: PropTypes.string,
    width: PropTypes.number,
    onClose: PropTypes.func,
    title: PropTypes.string,
    authService: PropTypes.shape({
      acceptRoute: PropTypes.func.isRequired,
    }).isRequired,
    viewService: PropTypes.shape({
      getComponent: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    variant: 'permanent',
    width: undefined,
    onClose: undefined,
    title: undefined,
  }

  constructor(props) {
    super(props);
    const { viewService } = props;
    this.HeaderComp = viewService.getComponent(APP_NAV_DRAWER_HEADER_TYPE);
  }

  render() {
    const { open, variant, width, title, authService, ...drawersProps } = this.props;
    const { routes, sortedRoutes } = drawersProps;

    const routeInDrawer = route => (route.drawer === undefined) || route.drawer;
    const generatePrimaryDrawerLinks = (trailing) => {
      let comps = [];
      routes.filter(route => routeInDrawer(route) && (Boolean(route.trailingMenu) === trailing)).forEach((route) => {
        const dwRoutes = route.getSelectableRoutes ? route.getSelectableRoutes(drawersProps) : [route];
        // if (dwRoutes.length > MAX_VERTICAL_LINKS_PER_ROUTE) {

        // }
        comps = comps.concat(dwRoutes.map(dwRoute => <VerticalDrawerLink route={dwRoute} {...drawersProps} key={`PrimDrawer${dwRoute.id}`} />));
      });
      return comps;
    };

    const DrawerComp = (
      <Drawer
        variant={variant}
        classes={{
          paper: classNames('drawer-paper', !open && 'drawer-paper-close', 'tuc-drawer'),
        }}
        style={variant === 'temporary' ? { width: `${width}px` } : {}}
        open={open}
        onClose={this.props.onClose}
      >
        {this.HeaderComp && <this.HeaderComp {...this.props} title={title} />}
        <div className="tuc-drawer-content">
          <div className="tuc-drawer-bar tuc-drawer-primary-bar">
            <div className="tuc-drawer-bar-center">
              {generatePrimaryDrawerLinks(false)}
            </div>
            {generatePrimaryDrawerLinks(true)}
          </div>
          <div className="tuc-drawer-bar tuc-drawer-secondary-bar">
            <Switch>
              {sortedRoutes.map((route) => {
                return (
                  <Route
                    path={route.matchPath}
                    key={`SecDrawer${route.id}`}
                    render={() => {
                      const Component = route.NavComponent || DrawerLinks;
                      return (
                        <Component {...drawersProps} authService={authService} route={route} key={`SecDrawer${route.id}`} />
                      );
                    }}
                  />
                );
              })}
            </Switch>
          </div>
        </div>
      </Drawer>
    );
    return (
      <div className="grb-navdrawer-wrapper">
        {this.props.open && DrawerComp}
      </div>
    );
  }
}

export default NavDrawer;
